"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownListView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../index");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var DropdownListView = exports.DropdownListView = function DropdownListView(_ref) {
  var _props$list$;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var moreStr = "More";
  var _useState = (0, _react.useState)(props.list[0].text),
    _useState2 = _slicedToArray(_useState, 2),
    labelVal = _useState2[0],
    setLabelVal = _useState2[1];
  var _useState3 = (0, _react.useState)(props.list[0].value),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    storedValue = _useState6[0],
    setStoredValue = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    storedLabelValue = _useState8[0],
    setStoredLabelValue = _useState8[1];
  (0, _react.useEffect)(function () {
    if (storedValue && value !== storedValue) {
      if (storedLabelValue === moreStr) {
        setValue(props.list[0].value);
        setLabelVal(props.list[0].text);
      } else {
        setValue(storedValue);
        setLabelVal(storedLabelValue);
      }
    }
  }, [storedValue, storedLabelValue]);
  (0, _react.useEffect)(function () {
    setValue(props.list[0].value);
    setStoredValue(props.list[0].value);
    setLabelVal(props.list[0].text);
    setStoredLabelValue(props.list[0].text);
    props.itemSelected && props.itemSelected(props.list[0].value, props.list[0].text);
  }, [(_props$list$ = props.list[0]) === null || _props$list$ === void 0 ? void 0 : _props$list$.value]);
  (0, _react.useEffect)(function () {
    if (value !== moreStr && storedValue === moreStr) {
      setStoredValue(value);
      setStoredLabelValue(labelVal);
    }
  }, [value, labelVal]);
  var setValLabel = function setValLabel(selectedValue, selectedText) {
    setValue(selectedValue);
    setLabelVal(selectedText);
    props.itemSelected && props.itemSelected(selectedValue, selectedText);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown-container"
  }, /*#__PURE__*/_react["default"].createElement(_index.DropdownWithList, {
    inputRequired: true,
    inputString: "More",
    list: props.list,
    isValid: true,
    setValue: setValLabel,
    label: labelVal,
    value: value,
    setLength: props.setLength,
    changeZIndex: props.changeZIndex,
    storedValue: storedValue,
    setStoredValue: setStoredValue,
    setStoredLabelValue: setStoredLabelValue,
    isSkuGroupSearch: props.isSkuGroupSearch,
    qtyOnBlur: props.qtyOnBlur,
    forceInput: props.forceInput,
    inputIdentifier: props.inputIdentifier,
    inputLabel: props.inputLabel
  }));
};
//# sourceMappingURL=DropdownListView.js.map